<template>
  <section id="channelView" class="statv_container statv_page_bg">
    <div class="channel_wrapper statv_wrapper">
      <h1 class="channel_title">채널번호</h1>
      <div class="channel_table" v-if="!isMobile">
        <ul class="channel_name">
          <li v-for="(list, idx) in channel_name" :key="idx">
            <div>
              <i></i><span>{{ list.name }}</span> <img :src="list.url" alt="" />
            </div>
            <!-- <div v-else><i></i><span>{{ list.mo_name }}</span>  <img style="height: 20px;" :src="list.url" alt=""></div> -->
          </li>
        </ul>
        <ul class="channel_desc">
          <li class="tv_type">
            <div>IPTV</div>
            <div>위성방송</div>
            <div>케이블 TV</div>
          </li>
          <li class="platforms">
            <div v-for="(list, idx) in platforms" :key="idx">
              <p v-if="!isMobile">{{ list.name }}</p>
              <p v-else>{{ list.mo_name }}</p>
            </div>
          </li>
          <li class="prime">
            <div v-for="(list, idx) in prime" :key="idx">
              <p v-if="!isMobile">{{ list.num }}</p>
              <p style="white-space: pre-wrap;" v-if="isMobile">
                {{ list.mo_num }}
              </p>
            </div>
          </li>
          <li class="prime">
            <div v-for="(list, idx) in prime2" :key="idx">
              <p v-if="!isMobile">{{ list.num }}</p>
              <p style="white-space: pre-wrap;" v-if="isMobile">
                {{ list.mo_num }}
              </p>
            </div>
          </li>
          <li>
            <div v-for="(list, idx) in primePlus" :key="idx">
              <p>{{ list.num }}</p>
            </div>
          </li>
          <li class="contact">
            <div v-for="(list, idx) in contactNum" :key="idx">
              <p v-if="!isMobile">
                {{ list.num }}
                <span
                  v-if="idx == 0 || idx == 1 || idx == 2"
                  @click="goOuterSite(idx)"
                  class="register_btn"
                  >가입</span
                >
              </p>
              <p v-else>
                <a :href="'tel:' + `${list.num}`">{{ list.num }}</a>
              </p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 모바일 ver -->
      <!------------------------------------->
      <!-- 모바일 ver -->
      <div class="channel_table" v-else>
        <div>
          <div
            v-for="(ch, idx) in channel_name_mobile"
            :key="idx"
            @click="changeChannel(ch.name)"
          >
            <!-- <div><i></i><span>{{ list.name }}</span> <img :src="list.url" alt=""></div> -->
            <p>
              <img
                v-if="
                  $route.query.ch
                    ? $route.query.ch == ch.name
                    : ch.name == 'prime'
                "
                style="height: 100%; cursor: pointer;"
                :src="ch.mo_url"
                alt=""
              />
              <img
                v-else
                style="height: 100%; cursor: pointer;"
                :src="ch.mo_url_b"
                alt=""
              />
            </p>
            <!-- <div v-else><i></i><span>{{ list.mo_name }}</span>  <img style="height: 20px;" :src="list.url" alt=""></div> -->
          </div>
        </div>
        <ul class="channel_name">
          <li>
            <div><span></span></div>
          </li>
          <li>
            <div><span>채널번호</span></div>
          </li>
          <li>
            <div><i></i><span>가입문의</span></div>
          </li>
        </ul>
        <ul class="channel_desc">
          <li class="tv_type">
            <div>IPTV</div>
            <div>위성방송</div>
            <div>케이블 TV</div>
          </li>
          <li class="platforms">
            <div v-for="(list, idx) in platforms" :key="idx">
              <p>{{ list.name }}</p>
            </div>
          </li>
          <li
            class="prime"
            v-if="$route.query.ch == 'prime' || !$route.query.ch"
          >
            <div v-for="(list, idx) in prime" :key="idx">
              <p>{{ list.num }}</p>
            </div>
          </li>
          <li class="prime" v-if="$route.query.ch == 'prime2'">
            <div v-for="(list, idx) in prime2" :key="idx">
              <p>{{ list.num }}</p>
            </div>
          </li>
          <li v-if="$route.query.ch == 'primep'">
            <div v-for="(list, idx) in primePlus" :key="idx">
              <p>{{ list.num }}</p>
            </div>
          </li>
          <li class="contact">
            <div v-for="(list, idx) in contactNum" :key="idx">
              <p v-if="!isMobile">{{ list.num }}</p>
              <p v-else>
                <a v-if="list.num" :href="'tel:' + `${list.num}`">
                  <span :class="`list_num_${idx}`">{{ list.num }}</span>
                  <!-- {{list.num}} -->
                </a>
                <a :href="'tel:' + `${list.m_num}`"
                  >{{ list.m_num }} {{ list.m_num_t }}</a
                >
                <a :href="'tel:' + `${list.m_num2}`"
                  >{{ list.m_num2 }} {{ list.m_num2_t }}</a
                >
                <a :href="'tel:' + `${list.m_num3}`"
                  >{{ list.m_num3 }} {{ list.m_num3_t }}</a
                >
                <span
                  v-if="idx == 0 || idx == 1 || idx == 2"
                  @click="goOuterSite(idx)"
                  class="register_btn"
                  >가입</span
                >
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div class="channel_footer">
        *가입 가능한 IPTV 및 지역 케이블 채널은 지속적으로 확대될 예정입니다
      </div>
    </div>
  </section>
</template>
<script>
import Utils from "@/helpers/utils.js";

export default {
  components: {},
  data() {
    return {
      mobile: false,
      channel_name_mobile: [
        {
          name: "prime",
          mo_url: require("@/assets/image/schedule/Prime_logo_channel_m.svg"),
          mo_url_b: require("@/assets/image/schedule/Prime_logo_channel_b_m.svg"),
        },
        {
          name: "prime2",
          mo_url: require("@/assets/image/schedule/Prime2_logo_channel_m.svg"),
          mo_url_b: require("@/assets/image/schedule/Prime2_logo_channel_b_m.svg"),
        },
        {
          name: "primep",
          mo_url: require("@/assets/image/schedule/Prime+_logo_channel_m.svg"),
          mo_url_b: require("@/assets/image/schedule/Prime+_logo_channel_b_m.svg"),
        },
      ],
      channel_name: [
        { name: "", mo_name: "" },
        {
          name: "",
          mo_name: "",
          url: require("@/assets/image/schedule/Prime_logo_w.png"),
        },
        {
          name: "",
          mo_name: "",
          url: require("@/assets/image/schedule/Prime2_logo_w.png"),
        },
        {
          name: "",
          mo_name: "",
          url: require("@/assets/image/schedule/Primw+_logo_w.png"),
        },
        { name: "가입문의", mo_name: "가입문의" },
      ],
      platforms: [
        { name: "KT지니TV", mo_name: "KT지니TV" },
        { name: "SK Btv	", mo_name: "SK Btv" },
        { name: "LG U+ tv", mo_name: "LG U+ tv" },
        { name: "Skylife", mo_name: "Skylife" },
        { name: "LG헬로비전", mo_name: "LG헬로비전" },
        { name: "Btv cable", mo_name: "Btv cable" },
        { name: "현대 HCN", mo_name: "현대 HCN" },
        { name: "딜라이브", mo_name: "딜라이브" },
        { name: "CMB", mo_name: "CMB" },
        { name: "제주방송", mo_name: "제주방송" },
        { name: "남인천방송", mo_name: "남인천방송" },
        { name: "JCN 울산중앙방송", mo_name: "울산중앙방송" },
        { name: "푸른방송", mo_name: "푸른방송" },
        { name: "서경방송", mo_name: "서경방송" },
        { name: "충북방송", mo_name: "충북방송" },
      ],
      prime: [
        { num: "190번", mo_num: "190번" },
        { num: "989번", mo_num: "989번" },
        { num: "110번", mo_num: "110번" },
        { num: "212번", mo_num: "212번" },
        { num: "117번", mo_num: "117번" },
        { num: "984번", mo_num: "984번" },
        { num: "498번", mo_num: "498번" },
        { num: "914번", mo_num: "914번" },
        { num: "201번, 181번(대구)", mo_num: "201번, \n 181번(대구)" },
        { num: "120번", mo_num: "120번" },
        { num: "130번", mo_num: "130번" },
        { num: "222번", mo_num: "222번" },
        { num: "152번", mo_num: "152번" },
        { num: "109번", mo_num: "109번" },
        { num: "242번", mo_num: "242번" },
      ],
      prime2: [
        { num: "191번", mo_num: "191번" },
        { num: "988번", mo_num: "988번" },
        { num: "111번", mo_num: "111번" },
        { num: "213번", mo_num: "213번" },
        { num: "118번", mo_num: "118번" },
        { num: "983번", mo_num: "983번" },
        { num: "499번", mo_num: "499번" },
        { num: "913번", mo_num: "913번" },
        { num: "202번, 182번(대구)", mo_num: "202번, \n 182번(대구)" },
        { num: "121번", mo_num: "121번" },
        { num: "131번", mo_num: "131번" },
        { num: "223번", mo_num: "223번" },
        { num: "153번", mo_num: "153번" },
        { num: "110번", mo_num: "110번" },
        { num: "243번", mo_num: "243번" },
      ],
      primePlus: [
        { num: "192번" },
        { num: "987번" },
        { num: "109번" },
        { num: "214번" },
        { num: "116번" },
        { num: "985번" },
        { num: "-" },
        { num: "912번" },
        { num: "-" },
        { num: "122번" },
        { num: "-" },
        { num: "-" },
        { num: "-" },
        { num: "111번" },
        { num: "244번" },
      ],
      contactNum: [
        { num: "100" },
        { num: "106" },
        { num: "101" },
        { num: "1588-3002" },
        { num: "1855-1000" },
        { num: "1877-7000" },
        { num: "1877-8000" },
        {
          num: "",
          m_num: "1644-1100",
          m_num2: "1644-2100",
          m_num3: "1877-5000",
          m_num_t: "(서울 전지역)",
          m_num2_t: "(경기지역)",
          m_num3_t: "(서울 강남)",
        },
        { num: "1544-3434" },
        { num: "070-8145-7777" },
        { num: "1544-0777" },
        { num: "1877-9100" },
        { num: "053-551-2000" },
        { num: "055-740-3001" },
        { num: "043-850-7000" },
      ],
    };
  },
  async created() {
    this.mobile = this.isMobile;
  },
  computed: {
    isMobile() {
      return Utils.isMobile();
    },
  },
  methods: {
    changeChannel(newChannel) {
      const newPath = `/channel?ch=${newChannel}`;
      const currentPath = this.$route.fullPath;

      if (newPath !== currentPath) {
        this.$router.push({ path: "/channel", query: { ch: newChannel } });
      }
    },
    goOuterSite(idx) {
      let url;
      switch (idx) {
        case 0:
          url =
            "https://product.kt.com/wDic/productDetail.do?ItemCode=1609&CateCode=6009&filter_code=88&option_code=120&pageSize=10";
          break;
        case 1:
          url = this.mobile
            ? "https://www.bworld.co.kr/m/product/btv/extra_service.do?menu_id=P03020000&utm_source=bw_m&utm_medium=paidchannel&utm_campaign=product#GA_P03020000_TAG_1"
            : "https://www.bworld.co.kr/product/btv/extra_service.do?menu_id=P03020000&utm_source=bw&utm_medium=paidchannel&utm_campaign=product#GA_P03020000_TAG_7_SPAN_0";
          break;
        case 2:
          url =
            "https://www.lguplus.com/iptv/addon?catg=TV_0000003&pageNo=1#lilnk";
          break;
        default:
          return; // idx가 0, 1, 2가 아닌 경우 함수 종료
      }
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang="less">
#channelView {
  .channel_wrapper {
    background-color: #ffffff;
    display: flex;
    flex-flow: column wrap;
    .channel_title {
      display: flex;
      margin-top: 70px;
      padding-bottom: 30px;
      justify-content: center;
      align-items: center;
      color: #b1915b;
      font-size: 42px;
      font-weight: 900;
    }
    .channel_table {
      width: 100%;
      ul {
        margin: 0 0 2px 0;
        display: flex;
        li {
          list-style: none;
          font-size: 16px;
        }
      }
      .channel_name {
        background-color: #b1915b;
        li {
          // outline: 1px solid #fff;
          color: #fff;
          font-weight: bold;
          white-space: pre-line;
          height: 39px;
          line-height: 39px;
          font-size: 18px;
          text-align: center;
          &:nth-child(1) {
            width: 275px;
          }
          &:nth-child(2),
          &:nth-child(3),
          &:nth-child(4) {
            width: 175px;
          }
          &:nth-child(5) {
            width: 232px;
            height: 39px;
            & > div {
              position: relative;
              & > span {
                display: block;
              }
              & > i {
                position: absolute;
                display: block;
                top: 9px;
                left: 64px;
                width: 22px;
                height: 22px;
                &::after {
                  content: "";
                  display: block;
                  width: 100%;
                  height: 100%;
                  background-size: 18px 18px;
                  background-repeat: no-repeat;
                  background-image: url("~@/assets/image/schedule/phone_icon.png");
                }
              }
            }
          }
          & > div {
            width: 100%;
            height: 39px;
            & > img {
              margin-top: 9px;
              height: 22px;
            }
          }
        }
      }
      .channel_desc {
        padding-left: 15px;
        justify-content: flex-start;
        li {
          background-color: #fff;
          color: #8f8f8f;
          font-size: 18px;
          &:nth-child(2) {
            width: 180px;
          }
          &:nth-child(3),
          &:nth-child(4),
          &:nth-child(5) {
            width: 175px;
          }
          &:nth-child(6) {
            width: 232px;
          }
          & > div {
            box-sizing: border-box;
            border-bottom: 1px solid #8f8f8f;
            text-align: center;
            height: 45px;
            line-height: 45px;
            &:nth-child(8) {
              height: 135px;
              white-space: pre-line;
              & > p {
                line-height: 135px;
              }
            }
          }
        }
        .tv_type {
          // font-family: "BebasNeue";
          color: #b1915b !important;
          font-size: 18px;
          font-weight: bold;
          width: 120px;
          line-height: 120;
          & > div {
            &:nth-child(1) {
              height: 135px;
              line-height: 135px;
            }
            &:nth-child(3) {
              height: 585px;
              line-height: 585px;
            }
          }
        }
        .platforms {
          color: #b1915b !important;
          font-size: 18px;
          font-weight: bold;
        }
        .contact {
          & > div {
            .register_btn {
              position: relative;
              color: #f7f4ef;
              font-weight: 600;
              width: 64px;
              height: 32px;
              line-height: 32px;
              display: inline-block;
              border-radius: 4px;
              cursor: pointer;
              margin-left: 24px;
              background-color: #b1915b;
            }
            &:nth-child(8) {
              // background:red;
              line-height: 1.1;
              & > p {
                // background:blue;
                line-height: 22px;
                padding-top: 30px;
                &::before {
                  width: 100%;
                  height: 100%;
                  display: block;
                  content: "1644-1100 (서울 전지역)  \A 1644-2100 (경기지역)  \A 1877-5000 (서울 강남)";
                }
              }
              & > a {
                // background :red;
                line-height: 1.4;
              }
            }
            p > a {
              display: block;
              height: 100%;
              // line-height: 1.1;
              // background:red;
              color: #8f8f8f;
            }
          }
        }
      }
    }
    .channel_footer {
      color: #8f8f8f;
      font-size: 16px;
      margin-top: 23.5px;
      padding-left: 15px;
    }
  }
}

.m #channelView {
  min-height: 1515px;
  .channel_wrapper {
    .channel_title {
      font-size: 50px;
      margin-top: 105px;
      padding-bottom: 40px;
    }
    .channel_table {
      & > div {
        display: flex;
        padding-bottom: 40px;
        justify-content: space-around;
      }
      .channel_name {
        padding: 0px;
        height: 60px;
        & > :nth-child(1) {
          width: 260px;
        }
        & > :nth-child(2) {
          width: 220px;
        }
        & > :nth-child(3) {
          width: 230px;
        }
        & > li {
          height: 60px;
          line-height: 60px;
          & > div {
            position: relative;
            & > i {
              position: absolute;
              top: 20px;
              left: 54px;
              display: block;
              width: 18px;
              height: 18px;
              background-size: cover;
              background-image: url("~@/assets/image/schedule/phone_icon.png");
            }
          }
        }
      }
      .channel_desc {
        padding: 0;
        .contact {
          & > div {
            & > p {
              & > a {
                .list_num_0,
                .list_num_1,
                .list_num_2 {
                  display: inline-block;
                  transform: translateX(-40px);
                }
              }
            }
            position: relative;
            .register_btn {
              position: absolute;
              width: 48px;
              height: 28px;
              font-size: 13px;
              line-height: 28px;
              top: 15px;
              right: 70px;
              margin-left: 0;
            }
            & > p {
              &::before {
                background: red;
                display: none !important;
              }
            }
          }
        }
        & > li {
          font-size: 20px;
          & > div {
            height: 60px;
            line-height: 60px;
            &:nth-child(8) {
              height: 130px;
            }
          }
        }
        & > :nth-child(1) {
          width: 95px;
          & > :nth-child(1) {
            height: 180px;
            line-height: 180px;
          }
          & > :nth-child(3) {
            height: 730px;
          }
        }
        & > :nth-child(2) {
          width: 170px;
        }
        & > :nth-child(3) {
          width: 215px;
        }
        & > :nth-child(4) {
          width: 225px;
          & > :nth-child(8) {
            overflow: hidden;
            & > a {
              margin-top: 30px;
              // line-height:1 !important;
            }
          }
        }
      }
    }
  }
}
</style>
